import { useFormatMessage } from "@skilitics/localization";
import type { SlotId } from "@skilitics/nautilus-core-designer-data";

import { NodeDesigner } from "../NodeDesigner";
import { useSlotDesigner } from "./useSlotDesigner";

type SlotPropertiesProps = {
  slotId: SlotId;
};

export const SlotProperties = ({ slotId }: SlotPropertiesProps) => {
  const formatMessage = useFormatMessage(formatStrings);
  const { placeholder, resident } = useSlotDesigner(slotId);

  const node = resident && resident.config.assetId ? resident : placeholder;

  return node ? <NodeDesigner node={node} view="properties" /> : <div>{formatMessage("noPlaceholder")}</div>;
};

const formatStrings = {
  noPlaceholder: {
    en: "No placeholder",
  },
};
